var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("表单")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('n3-form', {
      ref: "form"
    }, [_c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "姓名",
        "label-col": 3
      }
    }, [_c('n3-input', {
      attrs: {
        "show-clean": "",
        "name": "name",
        "rules": [{
          type: 'required'
        }],
        "custom-validate": _vm.nameValidate
      },
      model: {
        value: (_vm.model.name),
        callback: function($$v) {
          _vm.model.name = $$v
        },
        expression: "model.name"
      }
    })], 1), _vm._v(" "), _c('p', [_c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "年龄",
        "label-col": 3
      }
    }, [_c('n3-input-number', {
      attrs: {
        "name": "age",
        "rules": [{
          type: 'number'
        }, {
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.age),
        callback: function($$v) {
          _vm.model.age = $$v
        },
        expression: "model.age"
      }
    })], 1), _vm._v(" "), _c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "地址",
        "label-col": 3
      }
    }, [_c('n3-cascader', {
      attrs: {
        "name": "address",
        "options": _vm.options,
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.address),
        callback: function($$v) {
          _vm.model.address = $$v
        },
        expression: "model.address"
      }
    })], 1), _vm._v(" "), _c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "生日",
        "label-col": 3
      }
    }, [_c('n3-datepicker', {
      attrs: {
        "name": "birthday",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.birthday),
        callback: function($$v) {
          _vm.model.birthday = $$v
        },
        expression: "model.birthday"
      }
    })], 1), _vm._v(" "), _c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "学校",
        "label-col": 3
      }
    }, [_c('n3-typeahead', {
      attrs: {
        "show-clean": "",
        "name": "学校",
        "data": _vm.schoolData,
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.school),
        callback: function($$v) {
          _vm.model.school = $$v
        },
        expression: "model.school"
      }
    })], 1), _vm._v(" "), _c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "爱好",
        "label-col": 3
      }
    }, [_c('n3-checkbox-group', {
      attrs: {
        "name": "hobby",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.hobby),
        callback: function($$v) {
          _vm.model.hobby = $$v
        },
        expression: "model.hobby"
      }
    }, [_c('n3-checkbox', {
      attrs: {
        "label": "0"
      }
    }, [_vm._v("看书")]), _vm._v(" "), _c('n3-checkbox', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("运动")]), _vm._v(" "), _c('n3-checkbox', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("旅行")])], 1)], 1)], 1), _vm._v(" "), _c('p', [_c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "性别",
        "label-col": 3
      }
    }, [_c('n3-radio-group', {
      attrs: {
        "name": "sex",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.sex),
        callback: function($$v) {
          _vm.model.sex = $$v
        },
        expression: "model.sex"
      }
    }, [_c('n3-radio', {
      attrs: {
        "label": "0"
      }
    }, [_vm._v("男")]), _vm._v(" "), _c('n3-radio', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('p', [_c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "专业",
        "label-col": 3
      }
    }, [_c('n3-select', {
      attrs: {
        "name": "sex",
        "options": _vm.profession,
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.profession),
        callback: function($$v) {
          _vm.model.profession = $$v
        },
        expression: "model.profession"
      }
    })], 1)], 1), _vm._v(" "), _c('p', [_c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "级别",
        "label-col": 3
      }
    }, [_c('n3-slider', {
      attrs: {
        "name": "level",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.level),
        callback: function($$v) {
          _vm.model.level = $$v
        },
        expression: "model.level"
      }
    })], 1)], 1), _vm._v(" "), _c('p', [_c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "开启状态",
        "label-col": 3
      }
    }, [_c('n3-switch', {
      attrs: {
        "name": "state",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.state),
        callback: function($$v) {
          _vm.model.state = $$v
        },
        expression: "model.state"
      }
    })], 1), _vm._v(" "), _c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "喜欢的明星",
        "label-col": 3
      }
    }, [_c('n3-multiple-input', {
      attrs: {
        "name": "star",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.star),
        callback: function($$v) {
          _vm.model.star = $$v
        },
        expression: "model.star"
      }
    })], 1), _vm._v(" "), _c('n3-form-item', {
      attrs: {
        "need": "",
        "label": "想说的话",
        "label-col": 3
      }
    }, [_c('n3-textarea', {
      attrs: {
        "name": "suggestion",
        "rules": [{
          type: 'required'
        }]
      },
      model: {
        value: (_vm.model.suggestion),
        callback: function($$v) {
          _vm.model.suggestion = $$v
        },
        expression: "model.suggestion"
      }
    })], 1)], 1), _vm._v(" "), _c('n3-form-item', [_c('n3-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.submit($event)
        }
      }
    }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("n3-from参数")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("事件")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("方法")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("n3-from-item参数")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h3', [_vm._v("待验证组件参数")]), _vm._v(" "), _vm._m(6)], 1)])]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("ref")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'form'")]), _vm._v(" >")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"姓名\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-input")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"name\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.name\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":custom-validate")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"nameValidate\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-input")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"年龄\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-input-number")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"age\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.age\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'number'},{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-input-number")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-input")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"地址\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-cascader")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"address\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":options")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"options\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.address\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-cascader")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"生日\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-datepicker")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"birthday\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.birthday\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-datepicker")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"学校\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-typeahead")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"学校\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.school\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":data")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"schoolData\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-typeahead")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"爱好\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox-group")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"hobby\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.hobby\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"0\"")]), _vm._v(">")]), _vm._v("看书"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"1\"")]), _vm._v(">")]), _vm._v("运动"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("value")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2\"")]), _vm._v(">")]), _vm._v("旅行"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-checkbox-group")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"性别\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-radio-group")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"sex\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.sex\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-radio")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"0\"")]), _vm._v(">")]), _vm._v("男"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-radio")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-radio")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"1\"")]), _vm._v(">")]), _vm._v("女"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-radio")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-radio-group")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"专业\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-select")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"sex\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":options")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'profession'")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.profession\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-select")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"级别\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-slider")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"level\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.level\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-slider")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"开启状态\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-switch")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"state\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.state\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-switch")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"喜欢的明星\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-multiple-input")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"star\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.star\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-multiple-input")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("need")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"想说的话\"")]), _vm._v("\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":label-col")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-textarea")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"suggestion\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v(" = "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"model.suggestion\"")]), _vm._v("\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":rules")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"[{type:'required'}]\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-textarea")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n\n   "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n       "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"primary\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"submit\"")]), _vm._v(" >")]), _vm._v("提交"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-form")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_vm._v("  methods: {\n    nameValidate (val) {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" ("), _c('span', {
    attrs: {
      "class": "hljs-regexp"
    }
  }, [_vm._v("/[\\u4E00-\\u9FA5\\uF900-\\uFA2D]/")]), _vm._v(".test(val)) {\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("validStatus")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'success'")]), _vm._v("\n        }\n      } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" {\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("validStatus")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'error'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("tips")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'请输入中文名'")]), _vm._v("\n        }\n      }\n    },\n    submit () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".$refs.form.validateFields("), _c('span', {
    attrs: {
      "class": "hljs-function"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-params"
    }
  }, [_vm._v("result")]), _vm._v(" =>")]), _vm._v(" {\n        "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log(result)\n     })\n    }\n  }\n}\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("horizontal")]), _vm._v(" "), _c('td', [_vm._v("布局方式  horizontal,inline")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("validate")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("是否打开验证")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("validateChange")]), _vm._v(" "), _c('td', [_vm._v("校验结果变化")]), _vm._v(" "), _c('td', [_vm._v("(validateResults)")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("validateFields")]), _vm._v(" "), _c('td', [_vm._v("校验")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("－")]), _vm._v(" "), _c('td', [_vm._v("表单项说明")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label-col")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', [_vm._v("表单项说明所占栅格数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("wrap-col")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', [_vm._v("表单项所占栅格数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("form-col")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', [_vm._v("表单元素所占栅格数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("need")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("必填标示红点")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("custom－validate")]), _vm._v(" "), _c('td', [_vm._v("Function`")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("自定义校验器")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("rules")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("－")]), _vm._v(" "), _c('td', [_vm._v("验证规则,如 "), _c('code', {
    pre: true
  }, [_vm._v("[{type: 'required' }, {type: 'maxlength=6' }, {type:'minlength=3'}, {type: 'phone' }, {type: 'number' }, {type: 'telephone' }, {type: 'email' }]")])])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-786410a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786410a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_zh/n3FormDocs.md
// module id = 914
// module chunks = 0